import React from 'react';
import { Collapse } from 'reactstrap';
import Parser from 'html-react-parser';

class Privacy extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false
        }

        this.toggleOpen = this.toggleOpen.bind(this);
    }

    toggleOpen() {
        this.setState({ open: !this.state.open });
    }

    render() {
        return (
            <div className="section-page">
                <h3 className="mb-4" style={{ marginTop: '30px', cursor: 'pointer' }}>PRIVACY</h3>
                <div className="row section-text intro-fade">
                    <div className="col">
                        {Parser(this.props.content.summary)}
                        <div>
                            {!this.state.open && 
                                <span onClick={this.toggleOpen} style={{ cursor: 'pointer', color: '#BD2E2A'}}>read more...</span>
                            }
                        </div>                        
                    </div>
                </div>
                <Collapse isOpen={this.state.open}>
                    {Parser(this.props.content.full)}
                    <div>
                        {this.state.open &&
                            <span onClick={this.toggleOpen} style={{ cursor: 'pointer', color: '#BD2E2A' }}>read less...</span>
                        }
                    </div>
                </Collapse>

            </div>
        )
    }
}

export default Privacy;


// WEBPACK FOOTER //
// ./src/views/Pages/Privacy/privacy.js